import { OffersEntity } from '../configs/entity.config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { OffersResponse } from '@dch/products-business-logic';
import { IOffer } from '@proximus/common-business-logic';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  constructor() {}

  getCopperOutPhasingOffer(): Observable<IOffer> {
    return EntityManager.getEntity(OffersEntity).pipe(
      map((entity: IEntity<OffersResponse>) => {
        if (entity.value?.offers && entity.value.offers.length > 0) {
          // take the first offer containing type "migrate_to_fiber"
          return entity.value.offers.find(
            (o: IOffer) =>
              o.types !== null && o.types.includes('migrate_to_fiber'),
          );
        } else {
          return undefined;
        }
      }),
    );
  }
}
